// extracted by mini-css-extract-plugin
export default {"empty-text":"styles__empty-text--O0XiL"};